import React from 'react';
import {PopoverMenuOptionProps} from "./option";

export default function OptionPill(props:PopoverMenuOptionProps) {

    const onMouseEnter = () => {
        props.onSetHelpMessage?.(props.option.hint)
    }

    const onMouseLeave = () => {
        props.onSetHelpMessage?.(null)
    }

    const onClick = () => {
        if (!props.option.disabled) props.onClick(props.option);
    }

    const classes = Classes('option', 'pill', {
        'highlighted': props.isHighlighted,
        disabled: props.option.disabled
    });

    const valueClasses = Classes('ui5-pillbox s26', 'w200', {
        ['gd-c-bgp-'+props.option.color]: !props.option.disabled && !!props.option.color,
        ['gd-c-pale-border-'+props.option.color]: !props.option.disabled && !!props.option.color,
        'default-color': props.option.disabled,
        disabled: props.option.disabled
    })

    const style : React.CSSProperties = props.option.description ? {
        height      : 'unset',
        minHeight   : '36',
        whiteSpace  : 'normal',
        // maxWidth    : 250,
    } : {}

    return (
        <div className      = {classes}
             style          = {style}
             onMouseEnter   = {onMouseEnter}
             onMouseLeave   = {onMouseLeave}
             onClick        = {onClick}>
            <div className="flex-column-left-top w-100-percent m-t-8 m-b-8">
                <div className="flex-row-left-center flex-wrap w-100-percent ui5-txt-no-accent-tiny">
                    <div className={valueClasses}>{props.option.label}</div>
                </div>

                {!!props.option.description &&
                    <div className="flex-row-left-center w-100-percent ui5-txt-no-accent-tiny m-t-5" style={{lineHeight: '140%'}}>
                        {props.option.description}
                    </div>}
            </div>
        </div>
    );

}
